export enum ZonesActions {
  GetZones = '[Pending] Get Zones',
  GetZonesSuccess = '[Success] Get Zones',
  GetZonesError = '[Error] Get Zones',
}
